export const isEmpty = (text: string) => text === undefined || text === null || text.length === 0;

export const areEqual = (first: string, second: string): boolean => {
	return first?.toLowerCase() === second?.toLowerCase();
};
